exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* No Permission Component Styles */\n.no-permission-content {\n  min-height: calc(100vh - 200px);\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  padding: 50px 20px;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/ldt/Desktop/afropay_admin/afropay-admin-frontend/src/app/main/no-permission/no-permission.component.css
// module id = ../../../../../src/app/main/no-permission/no-permission.component.css
// module chunks = main